export default function PurchaseDeliveryModel(dict) {
    this.address = dict.Address;
    this.zipcode = dict.Zipcode;
    this.contactNumber = dict.ContactNumber;
    this.firstName = dict.FirstName;
    this.lastName = dict.LastName;

    this.delivered = dict.Delivered;
    this.parcelNo = dict.PacelNo;
    this.expireIn = dict.ExpireIn;
    this.fullImageUrl = dict.FullImageUrl;
    this.id = dict.ID;
    this.isShipped = dict.IsShipped;
    this.isUsed = dict.IsUsed;
    this.isWinner = dict.IsWinner;
    this.itemNumber = dict.ItemNumber;
    this.minutesValidAfterUsed = dict.MinutesValidAfterUsed;
    this.modifyDate = dict.ModifyDate;
    this.name = dict.Name;
    this.nameEn = dict.NameEN;

    this.redeemDate = dict.RedeemDate;
    this.redeemKey = dict.RedeemKey;
    this.serial = dict.Serial;
    this.shippedStatus = dict.ShippedStatus;
    this.shippingDate = dict.ShippingDate;
    this.type = dict.Type;

    if (this.fullImageUrl) {
        if(this.fullImageUrl.indexOf("-large") < 0) {
            var newString = this.fullImageUrl.replace("?", "-large?");
            this.fullImageUrl = newString;
        }
    }
}
